'use strict';

import { useEffect } from 'react';
import { ENABLE_PIPELINE_STATUS, USE_PIPELINE_STATUS_API_MOCKS } from '@/config/env.config';
import {
	joinProjectPipelineTrackerGroup,
	leaveProjectPipelineTrackerGroup,
} from '@/services/projectsHub.service';

/**
 * Subscribe to ProjectsHub pipeline-status group for `projectId` (legacy group prefix `pipeline-tracker:`; SignalR hints → RTK invalidation elsewhere).
 * When the PipelineStatus feature flag is off, or `USE_PIPELINE_STATUS_API_MOCKS` is on (default), this is a **no-op**.
 * @param {string | undefined} projectId
 */
export function usePipelineStatusHub(projectId) {
	useEffect(() => {
		if (!ENABLE_PIPELINE_STATUS) return undefined;
		if (USE_PIPELINE_STATUS_API_MOCKS) return undefined;
		if (!projectId) return undefined;
		void joinProjectPipelineTrackerGroup(projectId);
		return () => {
			void leaveProjectPipelineTrackerGroup(projectId);
		};
	}, [projectId]);
}
